import { reducerRegistry } from '../../../../reducerRegistry';

import collectionsReducersMap from './collections/reducersMap';
import listsReducersMap from './lists/reducersMap';
import objectsReducersMap from './objects/reducersMap';

const combineMap = {
  collections: collectionsReducersMap,
  lists: listsReducersMap,
  objects: objectsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('faqContents', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/faqContents/reducers/static/combineRegistry.js